import { TestMonkeyEffects } from './test-monkey.effects';

export const effects: any[] = [TestMonkeyEffects];

export * from './test-monkey.effects';
